<template>
  <div
    class="d-flex items-items-center justify-content-center text-center mb-3"
    id="app"
  >
    <div
      v-bind:style="dndStyle"
      class="dnd d-flex justify-content-center align-items-center flex-column w-100"
    >
      <div class="row w-100 h-100">
        <div
          class="col d-flex align-items-center justify-content-center flex-column"
          @dragover="dragover"
          @dragleave="dragleave"
          @drop="drop"
        >
          <input
            @click="resetFileInputValue"
            type="file"
            name="fields[assetsFieldHandle][]"
            id="assetsFieldHandle"
            class="d-none"
            @change="onChange($event)"
            ref="file"
            :multiple="multiple"
            :accept="acceptFile"
          />
          <img src="../assets/upload_ico.png" alt="" class="w-25" />
          <label for="assetsFieldHandle" class="">
            Drop
            <span class="type">{{
              type === "track" ? "tracks" : "reference tracks"
            }}</span>
            in here <br />
            or <br />
            <span class="btn text-poppins">Browse</span>
          </label>
        </div>
      </div>
    </div>
    <!-- <div v-for="file in files" class="file-details col d-flex align-items-center justify-content-center flex-column">
            <h4>{{ file.file.name }}</h4>
            <p>{{ Math.round(file.file.size / 1024) }} KB</p>
        </div> -->
  </div>
</template>

<script>
export default {
  props: ["type", "acceptFile", "multiple", "category", "masterCredits"],
  data() {
    return {
      dndStyle: "background-color: #f0f0f0; border: 4px dashed #737375;"
    }; // Store our uploaded files}
  },
  computed: {
    elementList() {
      return this.$store.state.trackData.currentElement !== "" &&
        this.$store.state.trackData.currentMix !== ""
        ? 0
        : 1;
    },
    elementListClass() {
      return this.$store.state.trackData.currentElement !== "" &&
        this.$store.state.trackData.currentMix !== ""
        ? ""
        : "disable";
    }
  },
  methods: {
    addTrackFile(file) {
      // create current object with add details
      let objData = {
        element: this.$store.state.trackData.currentElement,
        mixType: this.$store.state.trackData.currentMix,
        file: file,
        uploadStatus: 0,
        id: window.crypto.randomUUID()
      };
      //   function to dispatch data
      this.addCurrentTrackData(objData);
    },
    onChange(e) {
      if (this.category === "mastering") {
        const targetFilesCount =
          this.$store.state.trackData.currentDataList.length +
          e.target.files.length;
        if (targetFilesCount > 1) {
          return this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "You can only upload one (1) song at a time!"
          });
        }
      }
      for (let i = 0; i <= e.target.files.length - 1; i++) {
        this.addTrackFile(e.target.files[i]);
        // if (
        //     e.target.files[i].name.split(".").length > 2 ||
        //     fileNameHasSpecialCharacters(e.target.files[i].name.split(".")[0])
        // ) {
        //     this.$swal.fire({
        //         icon: "error",
        //         title: "Unsupported filename...",
        //         text: "Filename must not contain special characters",
        //     });
        // } else {

        // }
      }
    },
    dragover(event) {
      event.preventDefault();
      this.dndStyle =
        "background-color: #cfdafd88; border: 4px dashed #b8c7fd;";
      // Add some visual fluff to show the user can drop its files
    },
    dragleave() {
      this.dndStyle = "background-color: #f0f0f0; border: 4px dashed #737375;";
    },
    drop(event) {
      if (this.category === "mastering") {
        event.preventDefault();
        const targetFilesCount =
          this.$store.state.trackData.currentDataList.length +
          event.dataTransfer.files.length;
        if (targetFilesCount > 1) {
          return this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "You can only upload one (1) song at a time!"
          });
        }
      }

      for (let i = 0; i <= event.dataTransfer.files.length - 1; i++) {
        this.addTrackFile(event.dataTransfer.files[i]);
      } // Trigger the onChange event manually
    },
    addCurrentTrackData(data) {
      if (this.$props.type == "ref") {
        this.$store.dispatch("trackData/currentRef", data);
      } else if (this.$props.type == "track") {
        this.$store.dispatch("trackData/currentData", data);
      } else {
        // else
      }
    },
    resetFileInputValue() {
      this.$refs.file.value = "";
    }
  }
};
</script>

<style scoped>
img {
  width: 50%;
}

h4,
p {
  color: white;
}

.dnd label {
  color: white !important;
}

.dnd {
  min-height: 23vh;
  /* padding: 50px 0px !important; */
  border-radius: 8px;
  border: 4px dashed #737375;
  position: relative;
  z-index: 0;
  background-color: transparent !important;
}

.btn {
  border-radius: 30px;
  padding: 6px 16px;
  background-color: #26ffd486;
  color: white;
  font-family: "Poppins", sans-serif !important;
}

.type {
  font-family: "Poppins", sans-serif !important;
  font-weight: bold;
}
</style>
